// Resolves a raw document type/name to the pair of i18next translation keys
// holding its "Required Documents" tooltip copy (one for "What it is", one
// for "Why we ask for it").
//
// Deliberately reuses what already exists instead of re-declaring it:
// - docsData.js already maps every raw document type (constants.js values)
//   to its label translation key (e.g. "Working life certificate" ->
//   "workingLifeCertificate") across every employment-type bucket. We flatten
//   all of those buckets into one reverse lookup and derive the tooltip keys
//   from that same label key (`${labelKey}TooltipWhatItIs` / `...WhyWeAskFor`).
// - skorLiteDocumentMap.js's `docsMap` already normalizes raw type aliases
//   from the analysis service (e.g. "Social Security Contribution Report")
//   to the canonical type string docsData.js expects — passed in as `docsMap`
//   by the caller (see DocItem.jsx) instead of re-importing it here.
const docsData = require("./docsData");

const DOC_TYPE_TO_LABEL_KEY = Object.assign(
  {},
  ...Object.entries(docsData)
    .filter(([bucketName]) => bucketName !== "CLAVE_DOCS") // array, not a type->key map
    .map(([, bucket]) => bucket)
);

function getDocumentTooltipKeys(rawDocType, docsMap = {}) {
  if (!rawDocType) return null;
  const labelKey =
    DOC_TYPE_TO_LABEL_KEY[rawDocType] ??
    DOC_TYPE_TO_LABEL_KEY[docsMap[rawDocType]];
  if (!labelKey) return null;
  return {
    whatItIsKey: `${labelKey}TooltipWhatItIs`,
    whyWeAskForKey: `${labelKey}TooltipWhyWeAskFor`,
  };
}

module.exports = { getDocumentTooltipKeys };
